module.exports = __webpack_public_path__ + "media/images/brand/app_text_400-5d634494d8b78b0f87753891f315bf73.png";